document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.mm-collection-desc__toggle').forEach(function(btn) {
    btn.addEventListener('click', function() {
      const content = btn.closest('.mm-collection-desc__content');
      const collapsed = content.querySelector('.mm-collection-desc__text--collapsed');
      const full = content.querySelector('.mm-collection-desc__text--full');

      const expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!expanded));

      if (!expanded) {
        collapsed.style.display = 'none';
        full.style.display = '';
        btn.textContent = 'Show less';
      } else {
        collapsed.style.display = '';
        full.style.display = 'none';
        btn.textContent = 'Show more';
      }
    });
    const content = btn.closest('.mm-collection-desc__content');
    content.querySelector('.mm-collection-desc__text--full').style.display = 'none';
  });
});